import { registerDecorator, ValidationArguments, ValidationOptions } from '@lgce/class-validator';

export const IsUnique = (
    prom: (text: string, originalTextKey: string, object?: any) => boolean | Promise<boolean>,
    originalTextKey?: string, validationOptions?: ValidationOptions,
) => {
    return (object: object, propertyName: string): void => {
        registerDecorator({
            name: 'isUnique',
            target: object.constructor,
            propertyName,
            constraints: [],
            options: validationOptions,
            validator: {
                // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
                async validate(value: any, args: ValidationArguments): Promise<boolean> {
                    let originalValue;

                    if (!value) {
                        return true;
                    }

                    if ((args.object as any).original) {
                        originalValue = (args.object as any).original[propertyName];
                    }
                    try {
                        return await prom(value, originalValue, args.object);
                    } catch (_) {
                        return false;
                    }
                },
            },
        });
    };
};
